import { ReactNode } from 'react';
import { FileSyncOutlined } from '@ant-design/icons';

const refileIcon: () => ReactNode = () => <FileSyncOutlined />;

export default refileIcon;
